import { useLocalization } from '@/hooks/use-localization';
import { SliderInput } from '@/isomorphic/components/forms/components/slider-input';
import { FormSlider } from '@/isomorphic/components/forms/components/form-slider';
import { SavingsCalculatorSelectorProps } from './savings-calculator';

export const GoalSavings = ({ state, updateState, ...props }: SavingsCalculatorSelectorProps) => {
    const { getCurrencySymbol, localize } = useLocalization();

    const formatNumber = (n: number) => n.toLocaleString('sv-SE');

    const getRangeDescription = (min: number, max: number) => {
        return localize('input-range-description').replace('{min}', formatNumber(min)).replace('{max}', formatNumber(max));
    };

    const currencySuffix = getCurrencySymbol();
    const yearSuffix = localize('year').toLowerCase();

    return (
        <>
            <fieldset className="r-m-0 r-flex r-flex-col r-border-none r-p-0">
                <legend className="r-sr-only">
                    {props.goalSavingsAmountLabel} - {localize('input-slider-group-description')}
                </legend>
                <SliderInput
                    label={props.goalSavingsAmountLabel}
                    suffix={currencySuffix}
                    min={props.goalSavingsMinAmount}
                    max={props.goalSavingsMaxAmount}
                    value={state.goalSavingsAmount}
                    onChange={value => updateState({ goalSavingsAmount: value })}
                    formatNumber={formatNumber}
                    rangeDescription={getRangeDescription(props.goalSavingsMinAmount, props.goalSavingsMaxAmount)}
                />
                <FormSlider
                    label={props.goalSavingsAmountLabel}
                    suffix={currencySuffix}
                    step={props.goalSavingsStepAmount}
                    min={props.goalSavingsMinAmount}
                    max={props.goalSavingsMaxAmount}
                    value={state.goalSavingsAmount}
                    onChange={value => updateState({ goalSavingsAmount: value })}
                    formatNumber={formatNumber}
                />
            </fieldset>
            <fieldset className="r-m-0 r-flex r-flex-col r-border-none r-p-0">
                <legend className="r-sr-only">
                    {props.goalSavingsYearLabel} - {localize('input-slider-group-description')}
                </legend>
                <SliderInput
                    label={props.goalSavingsYearLabel}
                    suffix={yearSuffix}
                    min={props.goalSavingsMinYear}
                    max={props.goalSavingsMaxYear}
                    value={state.goalSavingsYear}
                    onChange={value => updateState({ goalSavingsYear: value })}
                    formatNumber={formatNumber}
                    rangeDescription={getRangeDescription(props.goalSavingsMinYear, props.goalSavingsMaxYear)}
                />
                <FormSlider
                    label={props.goalSavingsYearLabel}
                    suffix={yearSuffix}
                    step={props.goalSavingsStepYear}
                    min={props.goalSavingsMinYear}
                    max={props.goalSavingsMaxYear}
                    value={state.goalSavingsYear}
                    onChange={value => updateState({ goalSavingsYear: value })}
                    formatNumber={formatNumber}
                />
            </fieldset>
        </>
    );
};
